import { getBaseURL, isLocal } from "./utils"

declare global {
	interface Window {
		env: any
	}
}

interface SSOConf {
	client_id: string
	login_url: string
}

interface Timeout {
	timeout: number
	commercial_timeout: number
}

interface PhronesisConf {
	url: string
	timeout: Timeout
}

interface PhronesisAuthConfig {
	url: string
	timeout: Timeout
}

interface Config {
	pingfed_config: SSOConf
	phronesis_api: PhronesisConf
	phronesis_auth_api: PhronesisAuthConfig
	base_url: string
	google_maps_client_id: string
	medallia_source: string
	medallia_feedback_form_id: string
	google_tag_manager_id: string
}

export const getConfig = (): Config => {
	const isLocalEnv = isLocal(window.location.href)
	const config: Config = isLocalEnv ? require("./env/local.json") : window.env
	config.base_url = getBaseURL()
	return config
}

const config: Config = getConfig()

export default config
